export function formatDate(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date
    .toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", "   ");
}

// helper to safely format dates for <input type="date" />
export const formatInputDate = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};


// Helper function for deep merging
export const deepMerge = (target, source) => {
    const result = { ...target };

    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === "object" &&
        !Array.isArray(source[key])
      ) {
        result[key] = deepMerge(result[key] || {}, source[key]);
      } else if (
        source[key] !== undefined &&
        source[key] !== null &&
        source[key] !== ""
      ) {
        // Only update if source has a meaningful value
        result[key] = source[key];
      }
    }

    return result;
  };

// Helper function to check if form is empty
export const isFormEmpty = (answers) => {
    if (!answers || Object.keys(answers).length === 0) return true;

    return Object.values(answers).every((v) => {
      if (v === "" || v === null || v === undefined) return true;
      if (Array.isArray(v)) return v.every((x) => !x);
      if (typeof v === "object") {
        // Check nested objects
        return Object.values(v).every(
          (nested) => nested === "" || nested === null || nested === undefined
        );
      }
      return false;
    });
  };

export const calculateTotalScore = (answers = []) =>
  answers.reduce((sum, a) => {
    if (a.score === "NA" || a.score === "N") return sum;
    return sum + (Number(a.points) || 0);
  }, 0);